import React from 'react'

import type { IColumnProps } from '../../Node/types'
import * as s from './PreviewColumn.module.scss'

const PreviewColumn: React.FC<IColumnProps> = ({ children, style }) => {
  return (
    <div className={s.column} style={style}>
      {children}
    </div>
  )
}

export default PreviewColumn
